"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyPremadeFlashcardDefinition = exports.AnyPremadeFlashcardDefinitionSchema = exports.isAnyNonMinimalPairPremadeFlashcardDefinition = exports.AnyNonMinimalPairPremadeFlashcardDefinitionSchema = exports.isMinimalPairFlashcardDefinition = exports.MinimalPairFlashcardDefinitionSchema = exports.isAnyPremadeFlashcard = exports.AnyPremadeFlashcardSchema = exports.isAnyNonMinimalPairPremadeFlashcard = exports.AnyNonMinimalPairPremadeFlashcardSchema = exports.isWordStressFlashcard = exports.WordStressFlashcardSchema = exports.isToneFlashcard = exports.ToneFlashcardSchema = exports.isStrokeOrderFlashcard = exports.StrokeOrderFlashcardSchema = exports.isSpellingFlashcard = exports.SpellingFlashcardSchema = exports.isPronounceFlashcard = exports.PronounceFlashcardSchema = exports.isMissingLetterFlashcard = exports.MissingLetterFlashcardSchema = exports.isMinimalPairFlashcard = exports.MinimalPairFlashcardSchema = exports.isAlphabetFlashcard = exports.AlphabetFlashcardSchema = exports.isAlphabetFlashcardDefinition = exports.BasePremadeFlashcardDefinitionSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const image_association_types_1 = require("../image_association_types");
const flashcard_common_types_1 = require("./flashcard_common_types");
const premade_flashcard_type_types_1 = require("./premade_flashcard_type_types");
exports.BasePremadeFlashcardDefinitionSchema = zod_1.z.object({
    order_in_set: zod_1.z.number(),
    set_id: zod_1.z.number(),
    type: premade_flashcard_type_types_1.AnyPremadeFlashcardTypeSchema,
});
const BasePremadeFlashcardSchema = exports.BasePremadeFlashcardDefinitionSchema.extend(flashcard_common_types_1.SrsInfoSchema.shape).extend({
    id: zod_1.z.string(),
    images: image_association_types_1.ImageSchema.array(),
    premade_id: zod_1.z.number(),
});
const AlphabetFlashcardDefinitionSchema = exports.BasePremadeFlashcardDefinitionSchema.extend({
    img_url: zod_1.z.string().optional(),
    img_url_handwriting: zod_1.z.string().optional(),
    img_url_mnemonic: zod_1.z.string().optional(),
    letter_audio_url: zod_1.z.string().optional(),
    letter_ipa_txt: zod_1.z.string().optional(),
    letter_learn_txt: zod_1.z.string(),
    letter_learn_txt_back: zod_1.z.string().optional(),
    notes: zod_1.z.string().optional(),
    type: premade_flashcard_type_types_1.AlphabetFlashcardTypeSchema,
    word_audio_url: zod_1.z.string(),
    word_gender: zod_1.z.string().optional(),
    word_ipa_txt: zod_1.z.string(),
    word_known_txt: zod_1.z.string(),
    word_learn_id: zod_1.z.string(),
    word_learn_missing_letter_img: zod_1.z.string().optional(),
    word_learn_txt: zod_1.z.string(),
    word_learn_txt_bold: zod_1.z.string().optional(),
    word_learn_txt_bold_img: zod_1.z.string().optional(),
    word_learn_txt_extra: zod_1.z.string().optional(),
    word_learn_txt_missing: zod_1.z.string().optional(),
    writing_form: zod_1.z.string().optional(),
});
exports.isAlphabetFlashcardDefinition = type_validation_helpers_1.getTypeValidationFunction(AlphabetFlashcardDefinitionSchema);
exports.AlphabetFlashcardSchema = AlphabetFlashcardDefinitionSchema.extend(BasePremadeFlashcardSchema.shape).extend({ type: premade_flashcard_type_types_1.AlphabetFlashcardTypeSchema });
exports.isAlphabetFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.AlphabetFlashcardSchema);
const BaseMinimalPairFlashcardDefinitionSchema = exports.BasePremadeFlashcardDefinitionSchema.extend({
    type: premade_flashcard_type_types_1.MinimalPairFlashcardTypeSchema,
    word1_audio_url: zod_1.z.string(),
    word1_ipa_txt: zod_1.z.string(),
    word1_known_txt: zod_1.z.string(),
    word1_txt: zod_1.z.string(),
    word2_audio_url: zod_1.z.string(),
    word2_ipa_txt: zod_1.z.string(),
    word2_known_txt: zod_1.z.string(),
    word2_txt: zod_1.z.string(),
});
exports.MinimalPairFlashcardSchema = BaseMinimalPairFlashcardDefinitionSchema.extend(BasePremadeFlashcardSchema.shape).extend({ type: premade_flashcard_type_types_1.MinimalPairFlashcardTypeSchema });
exports.isMinimalPairFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.MinimalPairFlashcardSchema);
const BaseMissingLetterFlashcardDefinitionSchema = exports.BasePremadeFlashcardDefinitionSchema.extend({
    img_url: zod_1.z.string().optional(),
    img_url_handwriting: zod_1.z.string().optional(),
    img_url_mnemonic: zod_1.z.string().optional(),
    letter_audio_url: zod_1.z.string().optional(),
    letter_ipa_txt: zod_1.z.string().optional(),
    letter_learn_txt: zod_1.z.string(),
    letter_learn_txt_back: zod_1.z.string().optional(),
    notes: zod_1.z.string().optional(),
    type: premade_flashcard_type_types_1.MissingLetterFlashcardTypeSchema,
    word_audio_url: zod_1.z.string(),
    word_gender: zod_1.z.string().optional(),
    word_ipa_txt: zod_1.z.string(),
    word_known_txt: zod_1.z.string(),
    word_learn_id: zod_1.z.string(),
    word_learn_missing_letter_img: zod_1.z.string().optional(),
    word_learn_txt: zod_1.z.string(),
    word_learn_txt_bold: zod_1.z.string().optional(),
    word_learn_txt_bold_img: zod_1.z.string().optional(),
    word_learn_txt_missing: zod_1.z.string().optional(),
    writing_form: zod_1.z.string().optional(),
});
exports.MissingLetterFlashcardSchema = BaseMissingLetterFlashcardDefinitionSchema.extend(BasePremadeFlashcardSchema.shape);
exports.isMissingLetterFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.MissingLetterFlashcardSchema);
const BasePronounceFlashcardDefinitionSchema = exports.BasePremadeFlashcardDefinitionSchema.extend({
    extra_tone_word: zod_1.z.string().optional(),
    extra_tone_word_audio: zod_1.z.string().optional(),
    gender: zod_1.z.string().optional(),
    img_url: zod_1.z.string().optional(),
    notes: zod_1.z.string().optional(),
    tone_numbers: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]).optional(),
    type: premade_flashcard_type_types_1.PronounceFlashcardTypeSchema,
    word_audio_url: zod_1.z.string(),
    word_gender: zod_1.z.string().optional(),
    word_ipa_txt: zod_1.z.string(),
    word_known_txt: zod_1.z.string(),
    word_learn_id: zod_1.z.string(),
    word_learn_txt: zod_1.z.string(),
    word_learn_txt_extra: zod_1.z.string().optional(),
    writing_form: zod_1.z.string().optional(),
});
exports.PronounceFlashcardSchema = BasePronounceFlashcardDefinitionSchema.extend(BasePremadeFlashcardSchema.shape).extend({ type: premade_flashcard_type_types_1.PronounceFlashcardTypeSchema });
exports.isPronounceFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.PronounceFlashcardSchema);
const BaseSpellingFlashcardDefinitionSchema = exports.BasePremadeFlashcardDefinitionSchema.extend({
    include_tones_instruction: zod_1.z.string().optional(),
    notes: zod_1.z.string().optional(),
    type: premade_flashcard_type_types_1.SpellingFlashcardTypeSchema,
    word_audio_url: zod_1.z.string(),
    word_ipa_txt: zod_1.z.string(),
    word_known_txt: zod_1.z.string(),
    word_learn_id: zod_1.z.string(),
    word_learn_txt: zod_1.z.string(),
    writing_form: zod_1.z.string().optional(),
});
exports.SpellingFlashcardSchema = BaseSpellingFlashcardDefinitionSchema.extend(BasePremadeFlashcardSchema.shape).extend({ type: premade_flashcard_type_types_1.SpellingFlashcardTypeSchema });
exports.isSpellingFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.SpellingFlashcardSchema);
const BaseStrokeOrderFlashcardDefinitionSchema = exports.BasePremadeFlashcardDefinitionSchema.extend({
    img_url: zod_1.z.string(),
    img_url_mnemonic: zod_1.z.string().optional(),
    letter_audio_url: zod_1.z.string().optional(),
    letter_ipa_txt: zod_1.z.string().optional(),
    letter_learn_txt: zod_1.z.string(),
    notes: zod_1.z.string().optional(),
    type: premade_flashcard_type_types_1.StrokeOrderFlashcardTypeSchema,
    word_audio_url: zod_1.z.string(),
    word_ipa_txt: zod_1.z.string(),
    word_known_txt: zod_1.z.string(),
    word_learn_id: zod_1.z.string(),
    word_learn_txt: zod_1.z.string(),
    word_learn_txt_bold: zod_1.z.string(),
    word_learn_txt_missing: zod_1.z.string(),
    writing_form: zod_1.z.string().optional(),
});
exports.StrokeOrderFlashcardSchema = BaseStrokeOrderFlashcardDefinitionSchema.extend(BasePremadeFlashcardSchema.shape).extend({ type: premade_flashcard_type_types_1.StrokeOrderFlashcardTypeSchema });
exports.isStrokeOrderFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.StrokeOrderFlashcardSchema);
const BaseToneFlashcardDefinitionSchema = exports.BasePremadeFlashcardDefinitionSchema.extend({
    extra_tone_word: zod_1.z.string().optional(),
    extra_tone_word_audio: zod_1.z.string().optional(),
    gender: zod_1.z.string().optional(),
    img_url: zod_1.z.string(),
    notes: zod_1.z.string().optional(),
    tone_numbers: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]).optional(),
    type: premade_flashcard_type_types_1.ToneFlashcardTypeSchema,
    word_audio_url: zod_1.z.string(),
    word_gender: zod_1.z.string().optional(),
    word_ipa_txt: zod_1.z.string(),
    word_known_txt: zod_1.z.string(),
    word_learn_id: zod_1.z.string(),
    word_learn_txt: zod_1.z.string(),
    word_learn_txt_extra: zod_1.z.string().optional(),
    writing_form: zod_1.z.string().optional(),
});
exports.ToneFlashcardSchema = BaseToneFlashcardDefinitionSchema.extend(BasePremadeFlashcardSchema.shape).extend({ type: premade_flashcard_type_types_1.ToneFlashcardTypeSchema });
exports.isToneFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.ToneFlashcardSchema);
const BaseWordStressFlashcardDefinitionSchema = exports.BasePremadeFlashcardDefinitionSchema.extend({
    img_url: zod_1.z.string().optional(),
    notes: zod_1.z.string(),
    type: premade_flashcard_type_types_1.WordStressFlashcardTypeSchema,
    word_audio_url: zod_1.z.string(),
    word_ipa_txt: zod_1.z.string(),
    word_known_txt: zod_1.z.string(),
    word_learn_id: zod_1.z.string(),
    word_learn_txt: zod_1.z.string(),
    word_learn_txt_bold: zod_1.z.string(),
    writing_form: zod_1.z.string().optional(),
});
exports.WordStressFlashcardSchema = BaseWordStressFlashcardDefinitionSchema.extend(BasePremadeFlashcardSchema.shape).extend({ type: premade_flashcard_type_types_1.WordStressFlashcardTypeSchema });
exports.isWordStressFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.WordStressFlashcardSchema);
exports.AnyNonMinimalPairPremadeFlashcardSchema = zod_1.z.union([
    exports.AlphabetFlashcardSchema,
    exports.MissingLetterFlashcardSchema,
    exports.PronounceFlashcardSchema,
    exports.SpellingFlashcardSchema,
    exports.StrokeOrderFlashcardSchema,
    exports.ToneFlashcardSchema,
    exports.WordStressFlashcardSchema,
]);
exports.isAnyNonMinimalPairPremadeFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.AnyNonMinimalPairPremadeFlashcardSchema);
exports.AnyPremadeFlashcardSchema = zod_1.z.union([
    exports.AnyNonMinimalPairPremadeFlashcardSchema,
    exports.MinimalPairFlashcardSchema,
]);
exports.isAnyPremadeFlashcard = type_validation_helpers_1.getTypeValidationFunction(exports.AnyPremadeFlashcardSchema);
exports.MinimalPairFlashcardDefinitionSchema = BaseMinimalPairFlashcardDefinitionSchema.extend({ id: zod_1.z.number() });
exports.isMinimalPairFlashcardDefinition = type_validation_helpers_1.getTypeValidationFunction(exports.MinimalPairFlashcardDefinitionSchema);
exports.AnyNonMinimalPairPremadeFlashcardDefinitionSchema = zod_1.z.union([
    AlphabetFlashcardDefinitionSchema.extend({ id: zod_1.z.number() }),
    BaseMissingLetterFlashcardDefinitionSchema.extend({ id: zod_1.z.number() }),
    BasePronounceFlashcardDefinitionSchema.extend({ id: zod_1.z.number() }),
    BaseSpellingFlashcardDefinitionSchema.extend({ id: zod_1.z.number() }),
    BaseStrokeOrderFlashcardDefinitionSchema.extend({ id: zod_1.z.number() }),
    BaseToneFlashcardDefinitionSchema.extend({ id: zod_1.z.number() }),
    BaseWordStressFlashcardDefinitionSchema.extend({ id: zod_1.z.number() }),
]);
exports.isAnyNonMinimalPairPremadeFlashcardDefinition = type_validation_helpers_1.getTypeValidationFunction(exports.AnyNonMinimalPairPremadeFlashcardDefinitionSchema);
exports.AnyPremadeFlashcardDefinitionSchema = zod_1.z.union([
    exports.MinimalPairFlashcardDefinitionSchema,
    exports.AnyNonMinimalPairPremadeFlashcardDefinitionSchema,
]);
exports.isAnyPremadeFlashcardDefinition = type_validation_helpers_1.getTypeValidationFunction(exports.AnyPremadeFlashcardDefinitionSchema);
//# sourceMappingURL=premade_flashcard_types.js.map